import { render } from "./Edit25Liquidation4.vue?vue&type=template&id=07892d70"
import script from "./Edit25Liquidation4.vue?vue&type=script&lang=js"
export * from "./Edit25Liquidation4.vue?vue&type=script&lang=js"

import "./Edit25Liquidation4.vue?vue&type=style&index=0&id=07892d70&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__